import { render, staticRenderFns } from "./CreateNewPassword.vue?vue&type=template&id=42a11b22&scoped=true"
import script from "./CreateNewPassword.vue?vue&type=script&lang=js"
export * from "./CreateNewPassword.vue?vue&type=script&lang=js"
import style0 from "./CreateNewPassword.vue?vue&type=style&index=0&id=42a11b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a11b22",
  null
  
)

export default component.exports